import { ToolRow } from "@/components/portal/tool-row";

type Tool = {
  toolSetupId: string;
  name: string;
  note: string;
  link: string;
  ownerEmail: string;
  state: "pending" | "configured";
  lastAskedAt: string | null;
};

type Props = {
  tool: Tool | null;
  readOnly: boolean;
  onToggle: (toolSetupId: string) => void;
  onAskOwner: (toolSetupId: string) => void;
  askingId: string | null;
};

export function ToolSetup({ tool, readOnly, onToggle, onAskOwner, askingId }: Props) {
  if (!tool) {
    return (
      <div className="rounded-lg border bg-muted/20 p-6 text-center text-sm text-muted-foreground">
        Nenhuma ferramenta vinculada a este recurso.
      </div>
    );
  }
  return (
    <div className="space-y-2">
      <ToolRow
        tool={tool}
        readOnly={readOnly}
        onToggle={onToggle}
        onAskOwner={onAskOwner}
        asking={askingId === tool.toolSetupId}
      />
    </div>
  );
}
